import blurDataURL from "@/utils/blurDataURL";
import { useTranslation } from "next-i18next";
import Image from "next/image";

export default function AboutUs() {
	const { t } = useTranslation("common");

	const handleNewClick = (link: string) => {
		window.location.href = link;
	};
	const handleMoreClick = () => {
		window.location.href = "https://rockflow.ai/about";
	};

	const cards = [
		{
			imageUrl: `https://web-cdn.rockflow.tech/rockflow-website/about-us/20240524150858.jpeg`,
			text: "Recently, Vakee Lai, Founder and CEO of RockFlow, was invited by Alibaba Cloud International to attend a financial technology going global summit held in Shanghai, China",
			link: "https://www.linkedin.com/feed/update/urn:li:activity:7199607681504985088",
		},
		{
			imageUrl: `https://web-cdn.rockflow.tech/rockflow-website/about-us/our-new-9296.jpeg`,
			text: "RockFlow team recently came to the University of Hong Kong to communicate with students offline",
			link: "https://www.linkedin.com/feed/update/urn:li:activity:7186658584401719296",
		},
	];

	return (
		<div className="text-white">
			<div className="bg-[#1C182E] h-0.5"></div>
			<div className="px-4.5 mt-9">
				<Image
					src="https://web-cdn.rockflow.tech/rockflow-website/layout/logo-dark@2x.png"
					alt="adv"
					width={113}
					height={38}
					loading="lazy"
				/>
			</div>
			<div className="px-4.5">
				<p className="text-lg font-semibold mt-9">{t("about-us")}</p>
				<div className="text-sm mt-3 font-normal">{t("about-us-desc")}</div>

				<p className="text-lg font-semibold mt-9 mb-3">{t("our-news")}</p>

				<div>
					{cards.map((card, index) => (
						<div
							key={index}
							className="group relative overflow-hidden rounded-md mb-6"
							onClick={() => handleNewClick(card.link)}
						>
							<div className="transform object-cover transition-transform duration-300 ease-linear group-hover:scale-105">
								<Image
									src={card.imageUrl}
									width={339 * 2}
									height={254 * 2}
									alt={card.text}
									placeholder="blur"
									blurDataURL={blurDataURL}
									loading="lazy"
								/>
							</div>
							<div
								className="absolute bottom-0 left-0 w-full p-4 lg:p-6"
								style={{
									background: "linear-gradient(180deg,transparent,rgba(0,0,0,.82) 70.5%)",
								}}
							>
								<div className="line-clamp-2 leading-[1.2] tracking-wide lg:leading-[1.3] text-sm text-left font-normal">
									<span title={card.text}>{card.text}</span>
								</div>
							</div>
						</div>
					))}
				</div>

				<div className="flex items-center" onClick={handleMoreClick}>
					<span className="mr-1.5">View More</span>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none">
						<path
							d="M7.24338 3L12 6.97115L7.24338 10.875M3 6.93744H12"
							stroke="#F1ECE8"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
				<div className="text-xs font-normal mt-3">{t("this-service-is-not-available-desc")}</div>
			</div>
		</div>
	);
}
